<template>
    <div class="cs4-cartEmpty">
        {{ dictionary.thereAreNoServicesInYourCart }}
        <img class="cs4-cartEmpty__icon" :src="dictionary.icons.sad" alt="Sad Icon Comprasocial"> 
        <div class="cs4-cartEmpty__continueToBuy" v-on:click="$emit('closeCart')">
            {{ dictionary.continueToBuy }}
        </div>
    </div>
</template>

<script>
export default {
    name: "CartEmpty",
    props: ['dictionary'],
    emits: ['closeCart']

}
</script>

<style lang="scss" scoped>
    .cs4-cartEmpty{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 1);
        border-radius: 25px;
        margin: 15px;
        padding: 25px 15px 15px 15px;
        color:rgba(27,100,135,0.5);
        font-size: 16px;
        font-weight: 500;
        max-width: 360px;
        margin: 35px auto;

        &__icon{
            margin: 15px 0;
        }

        &__continueToBuy{
            border-radius: 25px;
            height: 40px;
            background-color: #61CE70;
            color: white;
            padding: 0 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size:15px;
        }
    }
</style>